import { render, staticRenderFns } from "./HyperblockView.vue?vue&type=template&id=2d3b6cf2&scoped=true"
import script from "./HyperblockView.vue?vue&type=script&lang=js"
export * from "./HyperblockView.vue?vue&type=script&lang=js"
import style0 from "./HyperblockView.vue?vue&type=style&index=0&id=2d3b6cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b6cf2",
  null
  
)

export default component.exports